import { createRouter, createWebHistory } from 'vue-router'
import BtcView from '../views/BtcView.vue'
import store from '@/store'

const routes = [
  {
    path: '/',
    component: () => import(/* webpackChunkName: "about" */ '../views/article/ArticleView_List.vue')
  },
  {
    path: '/article/:id',
    component: () => import(/* webpackChunkName: "about" */ '../views/article/ArticleView_Show.vue'),
    props: true // 将路由参数作为组件的 props 传递
  },
  {
    path: '/login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/index.vue')
  },
  {
    path: '/register',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/register.vue')
  },
  {
    path: '/btc',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: BtcView,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/exam',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/exam/examView_index.vue'),
    meta: { requiresAuth: true },
    children:[{
      path: '', // 默认子路由，当访问/exam时显示
      component: () => import(/* webpackChunkName: "exam" */ '../views/exam/examView_index.vue')
    },{
      path: 'add', // 默认子路由，当访问/exam时显示
      component: () => import(/* webpackChunkName: "exam" */ '../views/exam/exam_add.vue')
    }]
  },
  {
    path: '/article',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/article/ArticleView_Add.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/article/edit/:id',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/article/ArticleView_Edit.vue'),
    meta: { requiresAuth: true },
    props: true // 将路由参数作为组件的 props 传递

  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import(/* webpackChunkName: "about" */ '../views/NotFoundView.vue'),
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  const isLoggedIn = store.state.isLoggedIn; // 假设 store.state.isLoggedIn 存储登录状态

  // 如果用户已登录但访问的是 /login，则跳转到 /admin
  if (to.path === '/login' && isLoggedIn) {
    alert('您已登录，正在跳转到管理页面');
    next('/admin');
  }
  // 如果路由需要登录权限但用户未登录，则跳转到登录页
  else if (to.meta.requiresAuth && !isLoggedIn) {
    next('/login');
  }
  // 其他情况正常放行
  else {
    next();
  }
})
export default router
